import { render } from "./NavBar3.vue?vue&type=template&id=ff62a862&scoped=true"
import script from "./NavBar3.vue?vue&type=script&lang=js"
export * from "./NavBar3.vue?vue&type=script&lang=js"

import "./NavBar3.vue?vue&type=style&index=0&id=ff62a862&lang=scss&scoped=true"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff62a862"]])

export default __exports__